import { render, staticRenderFns } from "./erm_board.vue?vue&type=template&id=397ed32e&scoped=true&"
import script from "./erm_board.vue?vue&type=script&lang=js&"
export * from "./erm_board.vue?vue&type=script&lang=js&"
import style0 from "./erm_board.vue?vue&type=style&index=0&id=397ed32e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397ed32e",
  null
  
)

export default component.exports